"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLog = void 0;
var _log = require("../../service/logging/log.js");
var _Log = require("../../constants/Log.js");
var _react = require("react");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook.js");
const DmsLog = _ref => {
  let {
    data = null,
    level = _Log.LogLevel.INFO,
    message = null,
    module = null,
    type = _Log.LogType.USER
  } = _ref;
  const token = (0, _DmsTokenHook.getToken)();
  (0, _react.useEffect)(() => {
    try {
      if (token) {
        (0, _log.log)(message, module, level, type, data, token);
      }
    } catch (error) {
      console.error(error);
    }
  }, [data, level, message, module, token, type]);
  return null;
};
exports.DmsLog = DmsLog;